import gsap from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import SplitText from "gsap/dist/SplitText";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

// `onScroll` is our own flag — callers use it to decide whether to set
// `scrollTrigger`, it is not a GSAP property. Passing it through made GSAP log
// "Invalid property onScroll set to true. Missing plugin? gsap.registerPlugin()"
// on every page load, so strip it before handing options to GSAP.
const stripLocalOptions = ({ onScroll, ...rest } = {}) => rest;

export const fade = (el, options = {}) => {
    gsap.to(el, {
        ease: "power3.inOut",
        duration: 0.75,
        autoAlpha: 1,
        y: 0,
        x: 0,
        scale: 1,
        ...stripLocalOptions(options)
    });
}

export const list = (parent, child, options = {}) => {
    gsap
        .timeline(stripLocalOptions(options))
        .set(parent, {
            autoAlpha: 1,
        })
        .from(child, {
            duration: 0.25,
            autoAlpha: 0,
            x: -4,
            ease: "sine.in",
            stagger: 0.05,
        });
}

export const lines = (el, options = {}) => {
    new SplitText(el, {
        type: "lines",
        linesClass: "line",
        mask: "lines",
        autoSplit: true,
        onSplit(self) {
            return gsap
                .timeline(stripLocalOptions(options))
                .set(el, { autoAlpha: 1 })
                .from(self.lines, {
                    yPercent: 100,
                    ease: "power3",
                    stagger: 0.05,
                });
        }
    });
}